unit PrepareNetNumberListType;

interface

uses
  PrepareNetNumberType;

type
  TPrepareNetNumberListType = array of TPrepareNetNumberType;

implementation

end.
